import AuthGuard from "@/middleware/auth";

export default [
  { path: "/cruise/inventory", name: "CruiseInventory", component: () => import("@/views/cruise/inventory"), beforeEach: AuthGuard },
  { path: "/cruise/master/destinations", name: "CruiseDestinations", component: () => import("@/views/cruise/destinations"), beforeEach: AuthGuard },
  { path: "/cruise/master/ships", name: "CruiseShips", component: () => import("@/views/cruise/ships"), beforeEach: AuthGuard },
  { path: "/cruise/bookings", name: "CruiseBookings", component: () => import("@/views/cruise/bookings"), beforeEach: AuthGuard },
  {
    path: "/cruise/inventory/details/:inventory_id",
    name: "CruiseDetails",
    component: () => import("@/views/cruise/details"),
    beforeEach: AuthGuard
  },
  /* Companies */
  { path: "/cruise/companies", name: "CruiseCompanies", component: () => import("@/views/cruise/companies"), beforeEach: AuthGuard },
  {
    path: "/cruise/companies/transactions",
    name: "CruiseCompaniesTransaction",
    component: () => import("@/views/cruise/companies"),
    beforeEach: AuthGuard
  }
];

/* const imagesrc = data.imagesrc.replace('https://services.dpauls.com/mediaserver', 'https://media.dpauls.com/drive-server') */
